/**
 * 码表入参
 * @export
 * @enum {string}
 */
export enum EnumCodeFlag {
  /** @name  SI部门*/
  SIDepartment = 'SI_Department',
  /** @name  tone服务商部门*/
  T1Department = 'T1_Department',
  /** @name  tone代理商部门*/
  AgentDepartment = 'Agent_Department',
  /** @name 纳税人类型*/
  SIPayTaxexType = 'SI_PayTaxexType',
  /** @name 发票种类*/
  SIInvoiceType = 'SI_InvoiceType',
  /** @name  负责行业*/
  SIIndustry = 'SI_ChargeOfIndustry',
  /** @name  技术能力*/
  SITechCapacity = 'SI_TechCapacity',
  /** @name  桌面级销售产品*/
  SITableProduct = 'SI_TableProduct',
  /** @name  企业级销售产品*/
  SIEnterProduct = 'SI_EnterProduct',
  /** @name  增值业务销售产品*/
  SIAppreciProduct = 'SI_AppreciProduct',
  /** @name  品牌占比*/
  SIProductPercent = 'SI_ProductPercent',
  /** @name  主营行业*/
  SIMainIndustry = 'SI_MainIndustry',
  /** @name  si部门-其他*/
  SIDepartment_other = 'SID9000',
  /** @name  t1部门-其他*/
  T1Department_other = 'SID9000',
  /** @name  部门-领导层*/
  SIDepartment_manage = 'SID1000',
}
/**
 * Rel 子类型
 * @export
 * @enum {string}
 */
export enum EnumRelSubType {
  /** SI：类型50 子类型500 */
  SI = '500',
  /** T1代理商：类型51 子类型501 */
  Agent = '501',
  /** T1服务商：类型52 子类型502 */
  Servier = '502',
}
